import {
  createFileRoute,
  Outlet,
  redirect,
  useMatchRoute,
} from "@tanstack/react-router";

import { GenerationsStatusBar } from "@/features/Generations/components/GenerationsStatusBar";
import { isGenerationsEnabled } from "@/features/Generations/flag";
import { MuiBox } from "@/orion/MuiComponents/MuiBox";

export const Route = createFileRoute("/_auth/generations/$siteId")({
  beforeLoad: ({ params }) => {
    if (!isGenerationsEnabled()) {
      throw redirect({
        to: "/dragon-tiles/$siteId",
        params: { siteId: params.siteId },
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const matchRoute = useMatchRoute();
  // The brand › group › SKUs bar describes a flow in progress; the Stories
  // index has no group yet, so only the `new/*` step routes show it.
  const isStoriesIndex = Boolean(
    matchRoute({ from: "/generations/$siteId", fuzzy: false }),
  );

  return (
    <MuiBox sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      {isStoriesIndex ? null : <GenerationsStatusBar siteId={siteId} />}
      <Outlet />
    </MuiBox>
  );
}
